/**
 * Adds support for the identity service as a top level
 * app.identityFor(serviceName) that returns a promise
 *  which resolves to a private and unique ID
 *
 * A small JavaScript library used to send a salted hash of a user's UID to partners.
 * It takes a privacy-first approach to ensure we can safely share sets of user data
 * between trusted third parties, while preventing the possibility of the sets being
 * matched between partners or the source of the data.
 */

import identityFor from '@voxmedia/identity-library';
import { getCookie, hasCookie } from '../../lib/cookies';
import Logger from '../../lib/logger';

export function identityMixin(ConcertAds) {
  /**
   * Adds a mixin for app.identityFor(service) to provide a unique
   * id for this user on this service.
   *
   * @param {String} serviceName the name of the service to create the identity for
   * @returns {Promise<String>} which resolve with a unique ID
   */
  ConcertAds.prototype.identityFor = async function(serviceName) {
    const ppidCookieName = this.settings.publisherProvidedIdCookieName || 'vmidv1';

    Logger.log(`Trying to get an identity for ${serviceName} for with cookie ${ppidCookieName}`);

    if (ppidCookieName && hasCookie(ppidCookieName)) {
      const id = await identityFor(serviceName, getCookie(ppidCookieName));
      Logger.log(`Returning identity for ${serviceName} - ${id}`);
      return id;
    }

    return null;
  };
}
